import { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../../enumeration/ApiStatusTypeEnum";
import { getCookie } from "../../../slidebar/components/DarkMode";
import * as actions from "../../redux/CompanyGameAction";
import { ManageGameForm } from "./ManageGameForm";

export const ManageGameDialog = ({
  setShow,
  show,
  setSwalProps,
  companycode,
  gametype,
  setIsShowLoading,
  item,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const queryRef = useRef();
  const fileInputRef = useRef(null);
  const [successCount, setSuccessCount] = useState(0);
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const [imagePreview, setImagePreview] = useState();

  const companyGameState = useSelector(
    ({ companyGame }) => companyGame,
    shallowEqual
  );

  const handleClose = () => {
    setShow(false);
    setSuccessCount(0);
  };

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  const saveValues = (queryParams) => {
    setIsShowLoading(true);
    if (!item) {
      const imagename = queryParams.image ? queryParams.image.name : "";

      const formData = new FormData();
      formData.append("imagename", imagename);
      formData.append(
        "imagepath",
        `${queryParams.gametype}/${queryParams.companycode}/`
      );
      formData.append("image", queryParams.image);
      queryRef.current = {
        action: "coreaddcompanygame",
        gameimage: imagename,
        ...queryParams,
        image: undefined,
      };

      companyGameState.companyList?.webImagePathLists.forEach(
        (webImagePath) => {
          dispatch(
            actions.createCompanyGame(formData, webImagePath.phppath)
          ).finally(() => {
            setSuccessCount((prev) => (prev += 1));
          });
        }
      );
    } else {
      dispatch(
        actions.manageGameRecord({
          action: "coreeditcompanygame",
          ...item,
          ...queryParams,
          image: undefined,
        })
      ).then((resp) => {
        resp = resp.data;
        setIsShowLoading(false);
        if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
          setShow(false);
          setSwalProps({
            show: true,
            icon: "success",
            title: intl.formatMessage({ id: "success" }),
            text: intl.formatMessage({ id: "editGameSuccessfully" }),
          });
        } else {
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        }
      });
    }
  };

  useEffect(() => {
    if (item) {
      dispatch(actions.fetchGameDetail(item)).then((resp) => {
        resp = resp.data;
        if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
          formikRef.current?.setFieldValue("gamenameen", resp.gamenameen);
          formikRef.current?.setFieldValue("gamenamecn", resp.gamenamecn);
          formikRef.current?.setFieldValue("gamecode", resp.gamecode);
          formikRef.current?.setFieldValue("category", resp.category);
          formikRef.current?.setFieldValue("gametag", resp.gametag);
          formikRef.current?.setFieldValue(
            "gamestatus",
            resp.status.toLowerCase()
          );
        }
      });
    }
  }, [item]);

  useEffect(() => {
    if (
      successCount &&
      companyGameState.companyList?.webImagePathLists &&
      successCount === companyGameState.companyList?.webImagePathLists.length
    ) {
      dispatch(actions.manageGameRecord(queryRef.current)).then((resp) => {
        resp = resp.data;
        setIsShowLoading(false);
        if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
          formikRef.current?.resetForm();
          formikRef.current?.setFieldValue("companycode", companycode);
          formikRef.current?.setFieldValue("gametype", gametype);
          if (fileInputRef.current) fileInputRef.current.value = "";
          setImagePreview(undefined);
          setSuccessCount(0);

          setSwalProps({
            show: true,
            icon: "success",
            title: intl.formatMessage({ id: "success" }),
            text: intl.formatMessage({ id: "createGameSuccessfully" }),
          });
        } else {
          setSuccessCount(0);
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        }
      });
    }
  }, [successCount, companyGameState.companyList]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        data-bs-theme={mode}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: item ? "editGame" : "addGame",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ManageGameForm
            formikRef={formikRef}
            saveValues={saveValues}
            fileInputRef={fileInputRef}
            show={show}
            imagePreview={imagePreview}
            setImagePreview={setImagePreview}
            companycode={companycode}
            gametype={gametype}
            item={item}
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => formikRef.current.submitForm()}
          >
            {intl.formatMessage({ id: "saveChanges" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
